import { TabKey } from '../../CustomersV2.types';

export const LAUNCH_PACK_URL =
  'https://www.coda.io/d/Welcome-to-iwocaPay_dx9e47R5IPf';

interface StatusInfoRow {
  name: string;
  description: string;
  information: string;
}

interface StatusInfoContent {
  /** Mirrors the column header this modal explains. */
  title: string;
  rows: StatusInfoRow[];
  /** Trailing half of the Launch pack sentence, after "Launch pack:". */
  launchPackCopy: string;
}

export const STATUS_INFO: Record<TabKey, StatusInfoContent> = {
  onboarding: {
    title: 'Onboarding progress',
    launchPackCopy:
      'Tips and tricks on the best ways to encourage customers at each stage of the onboarding journey',
    rows: [
      {
        name: 'Business details',
        description:
          'The customer has entered their email address and created an account to checkout.',
        information: 'They now need to fill in all their business details.',
      },
      {
        name: 'Security checks',
        description:
          'Just a few final security checks before they are ready to use their approved limit.',
        information: 'Remind your customer to complete their security checks.',
      },
    ],
  },
  spendingLimit: {
    title: 'Status',
    launchPackCopy:
      'Tips and tricks on the best ways to encourage customers at each stage of the journey.',
    rows: [
      {
        name: 'Ready to use',
        description: 'They can now use their approved limit.',
        information:
          'Let them know they can use their approved limit on their next purchase.',
      },
      {
        name: 'Time to refresh',
        description:
          'The amount shown is a customer’s estimated limit that needs to be confirmed.',
        information:
          'They’ll need to hit the refresh button or make a payment.',
      },
      {
        name: 'Declined',
        description: 'This customer has been declined.',
        information:
          'Sorry, we weren’t able to approve this customer for Pay Later.',
      },
    ],
  },
};
